var _path, _path2, _circle, _circle2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmbedded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.708 6.615a.436.436 0 0 0-.543.291l-1.83 6.045a.436.436 0 0 0 .833.252L7 7.16a.436.436 0 0 0-.29-.544zM8.931 6.615a.436.436 0 0 0-.543.291l-1.83 6.045a.436.436 0 0 0 .834.252l1.83-6.044a.436.436 0 0 0-.29-.544z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.564 0H.436A.436.436 0 0 0 0 .436v16.128c0 .24.195.436.436.436h16.128c.24 0 .436-.195.436-.436V.436A.436.436 0 0 0 16.564 0zM3.487.872h10.026v1.743H3.487V.872zm-2.615 0h1.743v1.743H.872V.872zm15.256 15.256H.872V3.488h15.256v12.64zm0-13.513h-1.743V.872h1.743v1.743z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.867,
    cy: 245.064,
    r: 13.128,
    transform: "matrix(.0332 0 0 .0332 0 0)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.867,
    cy: 360.592,
    r: 13.128,
    transform: "matrix(.0332 0 0 .0332 0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.254 12.641H10.2a.436.436 0 0 0 0 .872h4.054a.436.436 0 0 0 0-.872z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedded);
export default __webpack_public_path__ + "static/media/embedded.ce84f4a34ea7c420ceeafd01034984ba.svg";
export { ForwardRef as ReactComponent };